import { StatusRequest, StatusResponse } from '../../generated-service-lib/StatusService';
import { DataLoadStatusResponse } from 'services/types';
import { GeneratedStatusService } from '../generatedServices';

const getSafeDataLoadStatusResponse = (x: StatusResponse): DataLoadStatusResponse => {
  const document = x.document;
  if (typeof document !== 'object' || document === null) {
    throw 'Failed to find "document" on status entry ' + x.correlationId;
  }

  if (!('tableId' in document)) {
    const result: DataLoadStatusResponse = {
      ...x,
      document: { ...document, tableId: '' },
    };
    return result;
  }

  return x as DataLoadStatusResponse;
};
export class StatusService {
  readonly unvalidatedClient: GeneratedStatusService;
  constructor(domain?: string) {
    this.unvalidatedClient = new GeneratedStatusService(domain);
  }

  createStatusEntry = async (clientId: string, body: StatusRequest): Promise<DataLoadStatusResponse> => {
    const data = await this.unvalidatedClient
      .postStatusClientsByClientIdStatuses({
        clientId,
        body,
      })
      .then((res) => (typeof res.body === 'undefined' ? {} : res.body))
      .then((body) => (typeof body.data === 'undefined' ? {} : body.data));

    return getSafeDataLoadStatusResponse(data);
  };

  getStatusEntriesByFilter = async (clientId: string, body: {}): Promise<DataLoadStatusResponse[]> => {
    const data = await this.unvalidatedClient
      .postStatusClientsByClientIdStatusesQuery({
        clientId,
        body,
      })
      .then((res) => (typeof res.body === 'undefined' ? {} : res.body))
      .then((body) => (typeof body.data === 'undefined' ? [] : body.data));

    return data.map((x) => getSafeDataLoadStatusResponse(x));
  };
}
